//prettier-ignore
export const translations = {
  "appDescription": {
    pt: "Entregue arquivos digitais de forma automática com o Dijital",
    es: "Entrega archivos digitales de forma automática con el Dijital",
  },
  "loja": {
    pt: "Ver loja",
    es: "Ver tienda",
  },

  "feedback-dash": {
    pt: "Gostou do Dijital? Aproveite para deixar seu feedback.",
    es: "¿Te gustó Dijital? Aprovecha para dejar tu feedback",
  },

  "dash-produtos-desc": {
    pt: "Cadastre e gerencie os produtos digitais da sua loja.",
    es: "Registra y administra los productos digitales de tu tienda.",
  },

  "dash-galeria-desc": {
    pt: "Organize arquivos e mídias entregues automaticamente.",
    es: "Organiza archivos y medios entregados automáticamente.",
  },

  "dash-pedidos-desc": {
    pt: "Acompanhe pedidos e o status das entregas digitais.",
    es: "Sigue pedidos y el estado de las entregas digitales.",
  },

  "sidebar-produtos": {
    pt: "Produtos",
    es: "Productos",
  },

  "sidebar-midias": {
    pt: "Mídias",
    es: "Archivos",
  },

  "sidebar-passos": {
    pt: "Passos",
    es: "Paso a paso",
  },

  "sidebar-integracoes": {
    pt: "Integrações",
    es: "Integraciones",
  },

  "sidebar-galeria": {
    pt: "Galeria",
    es: "Galería",
  },

  "sidebar-email": {
    pt: "E-mail",
    es: "Correo electrónico",
  },

  "sidebar-configuracoes": {
    pt: "Configurações",
    es: "Configuraciones",
  },

  "sidebar-pagamentos": {
    pt: "Pagamentos",
    es: "Suscripción",
  },

  "sidebar-pagina-downloads": {
    pt: "Página de downloads",
    es: "Página de descargas",
  },

  "marca-agua": {
    pt: "Marca d'água",
    es: "Marca de agua",
  },

  "marca-agua-ativo": {
    pt: "Marca d'água é colocada em arquivos PDF e precisa estar ativa para que funcione.",
    es: "La marca de agua se coloca en archivos PDF y debe estar activa para que funcione.",
  },

  "marca-agua-cor-texto": {
    pt: "Cor dos textos",
    es: "Color de los textos",
  },
  "marca-agua-texto-cabecalho": {
    pt: "Texto do cabeçalho",
    es: "Texto del encabezado",
  },
  "marca-agua-texto-rodape": {
    pt: "Texto do rodapé",
    es: "Texto del pie de página",
  },
  "marca-agua-selecionar-imagem": {
    pt: "Selecionar Imagem",
    es: "Seleccionar Imagen",
  },
  "marca-agua-posicao-imagem": {
    pt: "Posição da imagem",
    es: "Posición de la imagen",
  },
  "marca-agua-opacidade-imagem": {
    pt: "Opacidade da Imagem (%)",
    es: "Opacidad de la Imagen (%)",
  },

    "aguarde": {
    pt: "Aguarde...",
    es: "Espere...",
  },
  "salvo-sucesso": {
    pt: "Salvo com sucesso!",
    es: "¡Guardado con éxito!",
  },

  "marca-agua-preview-imagem": {
    pt: "Preview da Imagem",
    es: "Preview de la Imagen",
  },

  "page-downloas-produto": {
    pt: "Produtos",
    es: "Productos",
  },

  "page-downloas-midia": {
    pt: "Mídias",
    es: "Archivos",
  },

  "page-downloas-pesquisa": {
    pt: "Pesquisa por produto ou mídia",
    es: "Pesquisa por producto o archivo",
  },

  "page-downloas-acessar-pagina": {
    pt: "Acessar página de downloads",
    es: "Acceder a la página de descargas",
  },

  "page-downloas-acessar-pagina-email": {
    pt: "E-mail utilizado na compra",
    es: "Correo electrónico utilizado en la compra",
  },

  "page-downloas-acessar-pagina-pedido": {
    pt: "Número do pedido (Apenas números)",
    es: "Número del pedido (Solo números)",
  },

  "alert-botao": {
    pt: "Ver como funciona",
    es: "Ver cómo funciona",
  },

  "alert-duvida": {
    pt: "Tem dúvidas?",
    es: "¿Tienes dudas?",
  },

  "alert-ajuda": {
    pt: "Veja como funciona o menu ajuda.",
    es: "Vea cómo funciona el menú ayuda",
  },

  "alert-dashboard": {
    pt: "Entenda como o Dijital pode trazer valor aos seus produtos.",
    es: "Mira cómo Dijital puede agregar valor a tus productos.",
  },
  "alert-produtos": {
    pt: "Vincule arquivos aos produtos disponíveis na sua loja.",
    es: "Vincule archivos a los productos disponibles en su tienda.",
  },
  "alert-midias": {
    pt: "Saiba quais arquivos estão disponíveis no seu Dijital e o que você pode fazer com eles.",
    es: "Descubre qué archivos están disponibles en tu Dijital y qué puedes hacer con ellos.",
  },
  "alert-pedidos": {
    pt: "Reenvie e-mails e gerencie seus pedidos.",
    es: "Gestiona tus pedidos y reenvia emails.",
  },
  "alert-personalizar": {
    pt: "Saiba como deixar o Dijital com a cara da sua marca.",
    es: "Descubre cómo personalizar Dijital y dejarlo con la imagen de tu marca.",
  },
  "alert-integracoes": {
    pt: "Veja como integrar o Dijital na sua plataforma.",
    es: "Descubre cómo integrar Dijital en tu plataforma.",
  },



  "Use o Dijital para adicionar mídias e links na sua loja virtual.": {
    pt: "Use o Dijital para adicionar arquivos e links na sua loja virtual.",
    es: "Use Dijital para agregar archivos digitales y enlaces en su tienda en línea.",
  },
  "Olá": {
    pt: "Olá",
    es: "Hola",
  },
  "Adicionar novo arquivo": {
    pt: "Adicionar novo arquivo",
    es: "Agregar nuevo archivos"
  },
  "Pesquisar Dúvidas Frequentes": {
    pt: "Pesquisar Dúvidas Frequentes",
    es: "Buscar Preguntas Frecuentes",
  },
  "Está procurando por algo na plataforma, use nosso campo de busca": {
    pt: "Está procurando por algo na plataforma, use nosso campo de busca",
    es: "¿Estás buscando algo en la plataforma?, utiliza nuestro campo de búsqueda",
  },
  "Total de": {
    pt: "Total de",
    es: "Total de",
  },
  "Total": {
    pt: "Total",
    es: "Total",
  },
  "downloads": {
    pt: "downloads",
    es: "descargas",
  },
  "cliques": {
    pt: "cliques",
    es: "clics",
  },
  "Mídias": {
    pt: "Mídias",
    es: "Archivos",
  },
  "Galeria": {
    pt: "Galeria",
    es: "Galería",
  },
  "cadastradas": {
    pt: "cadastradas",
    es: "registrados",
  },
  "Produtos": {
    pt: "Produtos",
    es: "Productos",
  },
  "cadastrados": {
    pt: "cadastrados",
    es: "registrados",
  },
  "Registrar": {
    pt: "Registrar",
    es: "Registro",
  },
  "Últimos 7 dias": {
    pt: "Últimos 7 dias",
    es: "Últimos 7 días",
  },
  "Nenhuma mídia possui cilque ou download": {
    pt: "Nenhuma mídia possui cilque ou download",
    es: "Ningún archivo posee clics o descargas",
  },
  "Cliques no link": {
    pt: "Cliques no link",
    es: "Clics en el link",
  },
  "Buscar": {
    pt: "Buscar",
    es: "Buscar",
  },
  "Pesquisar": {
    pt: "Pesquisar",
    es: "Buscar",
  },
  "Selecione produtos e vincule arquivos digitais para começar a vender": {
    pt: "Selecione produtos e vincule arquivos digitais para começar a vender",
    es: "Selecciona productos y vincula archivos digitales para empezar a vender",
  },
  "Anexar arquivos": {
    pt: "Anexar arquivos",
    es: "Adjuntar archivos",
  },
  "Ver variantes": {
    pt: "Ver variantes",
    es: "Ver variantes",
  },
  "Ver tudo": {
    pt: "Ver tudo",
    es: "Ver todo",
  },
  "Personalizar": {
    pt: "Personalizar",
    es: "Personalizar",
  },
  "personalizar-empty-title": {
    pt: "Personalize o Dijital",
    es: "Personaliza Dijital",
  },
  "personalizar-empty-desc": {
    pt: "Escolha no menu ao lado o que deseja personalizar e deixe a entrega digital com a cara da sua marca.",
    es: "Elige en el menú lateral qué deseas personalizar y deja la entrega digital con la imagen de tu marca.",
  },
  "personalizar-beneficio-checkout": {
    pt: "Personalize a tela de download pós-compra",
    es: "Personaliza la pantalla de download post-compra",
  },
  "personalizar-beneficio-downloads": {
    pt: "Configure o link da página de downloads",
    es: "Configura el enlace de la página de descargas",
  },
  "personalizar-beneficio-email": {
    pt: "Edite o e-mail enviado após a compra",
    es: "Edita el email enviado después de la compra",
  },
  "personalizar-beneficio-marca-agua": {
    pt: "Adicione marca d'água nos arquivos",
    es: "Agrega marca de agua a los archivos",
  },
  "personalizar-alert-delay": {
    pt: "As mudanças podem levar até 30min para refletir, por favor aguarde",
    es: "Los cambios pueden tardar hasta 30 min en reflejarse, por favor espere",
  },
  "Como Funciona": {
    pt: "Como Funciona",
    es: "Cómo Funciona",
  },
  "Personalizar checkout": {
    pt: "Personalizar checkout",
    es: "Personalizar checkout",
  },
  "Minhas mídias": {
    pt: "Meus arquivos",
    es: "Mis archivos",
  },
  "Confira suas mídias e anexos": {
    pt: "Confira suas mídias e anexos",
    es: "Verifique sus archivos multimedia y archivos adjuntos",
  },
  "Anexos": {
    pt: "Anexos",
    es: "Adjuntos",
  },
  "Extensão": {
    pt: "Extensão",
    es: "Extensión",
  },
  "Data": {
    pt: "Data",
    es: "Fecha",
  },
  "Ações": {
    pt: "Ações",
    es: "Acciones",
  },
  "Ver produtos": {
    pt: "Ver produtos",
    es: "Ver productos",
  },
  "Personalizar e-mail": {
    pt: "Personalizar e-mail",
    es: "Personalizar correo electrónico",
  },
  "Personalize o e-mail que será enviado ao seu cliente": {
    pt: "Personalize o e-mail que será enviado ao seu cliente",
    es: "Personalize el email que se enviará a su cliente",
  },
  "Assunto do e-mail": {
    pt: "Assunto do e-mail",
    es: "Asunto del email",
  },
  "Texto central": {
    pt: "Texto central",
    es: "Texto central",
  },
  "Texto do botão": {
    pt: "Texto do botão",
    es: "Texto del botón",
  },
  "Botão": {
    pt: "Botão",
    es: "Botón",
  },
  "Salvar alterações": {
    pt: "Salvar alterações",
    es: "Guardar cambios",
  },
  "Salvar": {
    pt: "Salvar",
    es: "Guardar",
  },
  "Fundo do botão": {
    pt: "Fundo do botão",
    es: "Fondo del botón",
  },
  "Fundo": {
    pt: "Fundo",
    es: "Fondo",
  },
  "Personalize sua tela de checkout": {
    pt: "Personalize sua tela de checkout",
    es: "Personalize la página del checkout",
  },
  "Todos": {
    pt: "Todos",
    es: "Todos",
  },
  "Plataformas": {
    pt: "Plataformas",
    es: "Plataformas",
  },
  "Pagamentos são feitos através do Empreender Plus": {
    pt: "Pagamentos são feitos através do Empreender Plus",
    es: "Los pagos se realizan a través de Empreender Plus",
  },
  "Empreender Plus é uma central de cadastros e pagamentos da Empreender, onde você receberá descontos por utilizar nossos aplicativos.": {
    pt: "Empreender Plus é uma central de cadastros e pagamentos da Empreender, onde você receberá descontos por utilizar nossos aplicativos.",
    es: "Empreender Plus es la central de suscripciones y pago de Empreender, donde recibirás descuentos por utilizar nuestras aplicaciones.",
  }, "Plano Contratado": {
    pt: "Plano Contratado",
    es: "Plan Contratado",
  },
  "Desconto": {
    pt: "Desconto",
    es: "Descuento",
  },
  "Validade": {
    pt: "Validade",
    es: "Vencimiento",
  },
  "Quantidade": {
    pt: "Quantidade",
    es: "Cantidad",
  },
  "Nota Fiscal": {
    pt: "Nota Fiscal",
    es: "Factura",
  },
  "Status": {
    pt: "Status",
    es: "Status",
  }, "Bem vindo ao Dijital": {
    pt: "Bem vindo ao Dijital",
    es: "Bienvenido a Dijital",
  },
  "Siga o passa a passo e comece a vender.": {
    pt: "Siga o passa a passo e comece a vender.",
    es: "Sigue el paso a paso y comienza a vender.",
  },
  "Conecte sua loja": {
    pt: "Conecte sua loja",
    es: "Conecte su tienda virtual",
  },
  "Escolha a plataforma de sua preferência e conecte ou crie a sua loja para começar a usar o Dijital.": {
    pt: "Escolha a plataforma de sua preferência e conecte ou crie a sua loja para começar a usar o Dijital.",
    es: "Elige tu plataforma de preferencia y conéctate o crea tu tienda virtual para empezar a usar Dijital.",
  },
  "Precisa de ajuda?": {
    pt: "Precisa de ajuda?",
    es: "¿Tienes alguna duda?",
  },
  "Assistir vídeo": {
    pt: "Assistir vídeo",
    es: "Ver el vídeo",
  }, "Ir para o FAQ": {
    pt: "Ir para o FAQ",
    es: "Ir al FAQ",
  },
  "Precisa de mais ajuda? Falar com o suporte": {
    pt: "Precisa de mais ajuda? Falar com o suporte",
    es: "¿Necesitas de más ayuda? Contacta nuestro soporte",
  },
  "Integrações": {
    pt: "Integrações",
    es: "Integraciones",
  },
  "Ajuda": {
    pt: "Ajuda",
    es: "Ayuda",
  },
  "Suporte": {
    pt: "Suporte",
    es: "Soporte",
  },
  "Vincular arquivo": {
    pt: "Vincular arquivo",
    es: "Vincular archivo",
  },
  "Adicione uma mídia (anexo) ao produto.": {
    pt: "Adicione uma mídia (anexo) ao produto.",
    es: "Agregue un archivo (adjunto) al producto.",
  },
  "Vá em produtos": {
    pt: "Vá em produtos",
    es: "Vaya a productos",
  },
  "Clique no ícone": {
    pt: "Clique no ícone",
    es: "Haga clic en el ícono",
  },
  "Selecione a mídia que deseja vincular": {
    pt: "Selecione a mídia que deseja vincular",
    es: "Seleccione el archivo que desea vincular",
  }, "Personalize seu email e sua página de checkout.": {
    pt: "Personalize seu email e sua página de checkout.",
    es: "Personalize su email y su página del checkout.",
  },
  "Armazenamento": {
    pt: "Armazenamento",
    es: "Almacenamiento",
  }, "Configurações": {
    pt: "Configurações",
    es: "Configuraciones",
  },
  "Deletar conta": {
    pt: "Deletar conta",
    es: "Eliminar cuenta",
  }, "Gostaria de deletar sua conta?": {
    pt: "Gostaria de deletar sua conta?",
    es: "¿Desea eliminar su cuenta?",
  },
  "Deseja excluir sua conta?": {
    pt: "Deseja excluir sua conta?",
    es: "¿Deseas eliminar tu cuenta?",
  }, "Confirmar": {
    pt: "Confirmar",
    es: "Confirmar",
  },
  "Sem resultados": {
    pt: "Sem resultados",
    es: "No se encontraron resultados",
  }, "Você ainda não subiu nenhum arquivo": {
    pt: "Você ainda não subiu nenhum arquivo",
    es: "Aún no has subido ningún archivo.",
  },
  "Você ainda não integrou com nenhuma plataforma": {
    pt: "Use o Dijital para adicionar arquivos e links na sua loja virtual.",
    es: "Aún no has integrado con ninguna plataforma, haga clic aquí para integrar",
  },
  "Você ainda não integrou com nenhuma plataforma, clique aqui para integrar": {
    pt: "Use o Dijital para adicionar arquivos e links na sua loja virtual.",
    es: "Aún no has integrado con ninguna plataforma, haga clic aquí para integrar",
  },
  "Passo a passo": {
    pt: "Passo a passo",
    es: "Paso a Paso"
  },
  "Pagamentos": {
    pt: "Pagamentos",
    es: "Pagos"
  },
  "Renomear": {
    pt: "Renomear",
    es: "Cambiar el nombre",
  },
  "Copiar link": {
    pt: "Copiar link",
    es: "Copiar enlace",
  },
  "Baixar arquivo": {
    pt: "Baixar arquivo",
    es: "Descargar archivo",
  },
  "Botão com tema da loja": {
    pt: "Botão com tema da loja",
    es: "Botón con tema de la tienda",
  },
  "Arredondamento do botão": {
    pt: "Arredondamento do botão",
    es: "Arredondamiento del botón",
  },
  "Deletar": {
    pt: "Deletar",
    es: "Eliminar",
  },
  "Limitar cliques": {
    pt: "Limitar cliques",
    es: "Limitar clics",
  },
  "Limitar downloads": {
    pt: "Limitar downloads",
    es: "Limitar descargas",
  },
  "Não possui uma conta?": {
    pt: "Não possui uma conta?",
    es: "¿No tienes una cuenta?",
  },
  "Esqueceu sua senha?": {
    pt: "Esqueceu sua senha?",
    es: "¿Olvidó su contraseña?",
  },
  "Senha": {
    pt: "Senha",
    es: "Contraseña",
  },
  "Confirmar Senha": {
    pt: "Confirmar Senha",
    es: "Confirmar Contraseña",
  },
  "ou acesse com": {
    pt: "ou acesse com",
    es: "o ingrese con",
  },
  "Política de Privacidade": {
    pt: "Política de Privacidade",
    es: "Política de privacidad",
  },
  "Política de Cookie": {
    pt: "Política de Cookie",
    es: "Política de cookies",
  },
  "Termos e condições": {
    pt: "Termos e condições",
    es: "Términos y condiciones",
  },
  "Confirmar senha": {
    pt: "Confirmar senha",
    es: "Confirmar contraseña",
  },
  "Experimente grátis": {
    pt: "Experimente grátis",
    es: "Pruébelo gratis",
  },
  "Já possui uma conta?": {
    pt: "Já possui uma conta?",
    es: "¿Usted ya tiene una cuenta?",
  },
  "Nome": {
    pt: "Nome",
    es: "Nombre",
  },
  "Chave Empreender": {
    pt: "Chave Empreender",
    es: "Llave Empreender",
  },
  "Erro ao tentar efetuar login.": {
    pt: "Erro ao tentar efetuar login.",
    es: "Error al intentar iniciar sesión",
  },
  "Login efetuado com sucesso.": {
    pt: "Login efetuado com sucesso.",
    es: "Inicio de sesión realizado con éxito.",
  },
  "Chave empreender copiada.": {
    pt: "Chave empreender copiada.",
    es: "Llave empreender copiada",
  },
  "Configuração Nuvemshop": {
    pt: "Configuração Nuvemshop",
    es: "Configuración Tiendanube",
  },
  "1. Faça o login em sua conta da nuvemshop que deseja integrar.": {
    pt: "1. Faça o login em sua conta da nuvemshop que deseja integrar.",
    es: "1. Inicie sesión en la cuenta Tiendanube que desea integrar.",
  },
  "2. Clique no botão Conectar. (você será redirecionado à nuvemshop para autorizar a integração e assim que terminar será redirecionado para o Dijital novamente.)": {
    pt: "2. Clique no botão Conectar. (você será redirecionado à nuvemshop para autorizar a integração e assim que terminar será redirecionado para o Dijital novamente.)",
    es: "2. Haga clic en el botón Conectar. (Usted será redirijido a Tiendanube para autorizar la integración y cuando finalize será redirijido de vuelta a la app Dijital).",
  },
  "3. Pronto sua loja já está integrada ao Dijital.": {
    pt: "3. Pronto sua loja já está integrada ao Dijital.",
    es: "3. ¡Listo! Su tienda ya está integrada a Dijital.",
  },
  "Não deslogue do Dijital durante o processo de integração.": {
    pt: "Não deslogue do Dijital durante o processo de integração.",
    es: "No cierre la sesión de Dijital durante el proceso de integración.",
  },
  "Personalize - opcional": {
    pt: "Personalize - opcional",
    es: "Personalizar - opcional",
  },
  "Personalize seu email": {
    pt: "Personalize seu email",
    es: "Personalize su email.",
  },
  "Personalize seu checkout": {
    pt: "Personalize seu checkout",
    es: "Personalize su checkout",
  },
  "Ir ao FAQ": {
    pt: "Ir ao FAQ",
    es: "Ir al FAQ",
  },
  "Precisa de mais ajuda?": {
    pt: "Precisa de mais ajuda?",
    es: "¿Necesitas de más ayuda?",
  },
  "Falar com o suporte": {
    pt: "Falar com o suporte",
    es: "Contacta nuestro soporte",
  },
  "Nuvemshop": {
    pt: "Nuvemshop",
    es: "Tiendanube",
  },
  "Gerenciar produto digital": {
    pt: "Gerenciar produto digital",
    es: "Gestionar productos digitales",
  },
  "[upload_limit] para upload": {
    pt: "150 MB para upload",
    es: "150 MB para subir",
  },
  "Plano atual": {
    pt: "Plano atual",
    es: "Plan actual",
  },
  "Deseja excluir essa integração com Nuvemshop ?": {
    pt: "Deseja excluir essa integração com Nuvemshop ?",
    es: "¿Deseas eliminar esta integración con Tiendanube?",
  },
  "Deseja excluir essa integração com Yampi ?": {
    pt: "Deseja excluir essa integração com Yampi ?",
    es: "¿Deseas eliminar esta integración con Yampi?",
  },
  "Deseja excluir essa integração com Woocommerce ?": {
    pt: "Deseja excluir essa integração com Woocommerce ?",
    es: "¿Deseas eliminar esta integración con Woocommerce?",
  },
  "Deseja excluir essa integração com Shopify ?": {
    pt: "Deseja excluir essa integração com Shopify ?",
    es: "¿Deseas eliminar esta integración con Shopify?",
  },
  "Deseja excluir essa integração com Rastreio ?": {
    pt: "Deseja excluir essa integração com Rastreio ?",
    es: "¿Deseas eliminar esta integración con Rastreio?",
  },
  "Botão que redireciona para tela de checkout": {
    pt: "Botão que redireciona para tela de checkout",
    es: "Botón que redirige a la página del checkout",
  },
  "[Nome do arquivo] / [Link]": {
    pt: "[Nome do arquivo] / [Link]",
    es: "[Nombre del archivo] / [Link]"
  },
  "[Nome do arquivo]": {
    pt: "[Nome do arquivo]",
    es: "[Nombre del archivo]"
  },
  "Sair": {
    pt: "Sair",
    es: "Salir"
  },
  "Esse é o código de indentificação desse aplicativo.": {
    pt: "Esse é o código de indentificação desse aplicativo.",
    es: "Este es el código de identificación de esta aplicación"
  },
  "Integre sua conta Nuvemshop e comece a adicionar produtos digitais na sua loja": {
    pt: "Integre sua conta Nuvemshop e comece a adicionar produtos digitais na sua loja",
    es: "Integre su cuenta Tiendanube y comience a incluir productos digitales en su tienda."
  },
  "Integre sua conta Yampi e comece a adicionar produtos digitais na sua loja": {
    pt: "Integre sua conta Yampi e comece a adicionar produtos digitais na sua loja",
    es: "Integre su cuenta Yampi y comience a incluir productos digitales en su tienda."
  },
  "Integre sua conta Woocommerce e comece a adicionar produtos digitais na sua loja": {
    pt: "Integre sua conta Woocommerce e comece a adicionar produtos digitais na sua loja",
    es: "Integre su cuenta Woocommerce y comience a incluir productos digitales en su tienda."
  },
  "Yampi": {
    pt: "Yampi",
    es: "Yampi"
  },
  "Woocommerce": {
    pt: "Woocommerce",
    es: "Woocommerce"
  },
  "Aguarde...": {
    pt: "Aguarde...",
    es: "Espere..."
  },
  "Integração efetuada com sucesso!": {
    pt: "Integração efetuada com sucesso!",
    es: "¡Integración realizada correctamente!"
  },
  "Integração deletada com sucesso!": {
    pt: "Integração deletada com sucesso!",
    es: "Integración eliminada con éxito."
  },
  "Integre sua conta Woocommerce e comece a criar avaliações e perguntas na sua loja": {
    pt: "Integre sua conta Woocommerce e comece a criar avaliações e perguntas na sua loja",
    es: "Integre su cuenta Woocommerce y comience a incluir productos digitales en su tienda"
  },
  "Adicionar novo anexo": {
    pt: "Adicionar novo anexo",
    es: "Añadir nuevo archivo"
  },
  "Fazer upload": {
    pt: "Fazer upload",
    es: "Subir archivo"
  },
  "Vincular mídia": {
    pt: "Vincular mídia",
    es: "Vincular archivo"
  },
  "Integre sua conta Shopify e comece a adicionar produtos digitais na sua loja": {
    pt: "Integre sua conta Shopify e comece a adicionar produtos digitais na sua loja",
    es: "Integre su cuenta Shopify y comience a incluir productos digitales en su tienda."
  },
  "Shopify": {
    pt: "Shopify",
    es: "Shopify"
  },
  "Pedidos": {
    pt: "Pedidos",
    es: "Pedidos"
  },
  "Pedido": {
    pt: "Pedido",
    es: "Orden"
  },
  "Você ainda não recebeu nenhum pedido depois que integrou sua loja com o Dijital": {
    pt: "Você ainda não recebeu nenhum pedido depois que integrou sua loja com o Dijital",
    es: "Todavía no has recibido ningún pedido después de integrar tu tienda con Dijital"
  },
  "Veja os pedidos feitos nas loja integradas": {
    pt: "Veja os pedidos feitos nas loja integradas",
    es: "Ver los pedidos realizados en las tiendas integradas"
  },

  //novas traduções
  "config-shopify": {
    pt: "Configuração Shopify",
    es: "Configuración Shopify"
  },
  "nao-deslogue": {
    pt: "Não deslogue do Dijital durante o processo de integração.",
    es: "No cierre sesión de la app Dijital durante el proceso de integración"
  },
  "crie-app": {
    pt: "Crie seu app privado na shopify",
    es: "Crea tu app privada en Shopify"
  },
  "permissoes": {
    pt: "Permissões necessárias: (Leitura e Escrita):",
    es: "Alcances de acceso requeridos (Lectura y Escritura)"
  },
  "produtos": {
    pt: "Produtos",
    es: "Productos"
  },
  "pedidos": {
    pt: "Pedidos",
    es: "Pedidos"
  },
  "lista-produtos": {
    pt: "Lista de produtos",
    es: "Publicaciones de productos"
  },
  "digite-infor": {
    pt: "Digite as informações da sua loja:",
    es: "Introduzca los datos de su tienda:"
  },
  "endereco-loja": {
    pt: "Endereço da loja",
    es: "URL de su tienda"
  },
  "token": {
    pt: "token",
    es: "Token de acceso"
  },

  "acao": {
    pt: "Ação",
    es: "Acción"
  },

  "integracao": {
    pt: "Integração",
    es: "Integración"
  },

  "progresso": {
    pt: "Progresso",
    es: "Progreso"
  },

  "feedback": {
    pt: "Feedback",
    es: "Feedback"
  },
  //

  "config-sak": {
    pt: "Configuração Sak",
    es: "Configuración SAK"
  },
  "digite-webhook": {
    pt: "Digite o webhook da conta SAK que deseja integrar:",
    es: "Introduzca el webhook de la cuenta SAK que desea integrar:"
  },
  "digite-token": {
    pt: "Digite o token da conta SAK que deseja integrar:",
    es: "Introduzca el token de la cuenta SAK que desea integrar:"
  },

  "existe-integracao": {
    pt: "já existe uma integração",
    es: "Ya existe una integración."
  },
  //
  "sales-nao-pedidos": {
    pt: "Você ainda não possuí pedidos.",
    es: "No tienes pedidos aún."
  },
  "sales-reenviar-emails": {
    pt: "Reenviar emails dos pedidos selecionados",
    es: "Reenviar emails de los pedidos seleccionados"
  },
  "sales-atualizar": {
    pt: "Atualizar",
    es: "Actualizar"
  },
  "sales-todos-pedidos": {
    pt: "Todos os pedidos",
    es: "Todos los pedidos"
  },
  "sales-desde": {
    pt: "Desde",
    es: "Desde"
  },
  "sales-ate": {
    pt: "Até",
    es: "Hasta"
  },
  "sales-pesquisar": {
    pt: "Pesquisar",
    es: "Buscar"
  },

  "sales-acessar": {
    pt: "Acessar",
    es: "Acceder"
  },
  "sales-salvar": {
    pt: "Salvar",
    es: "Guardar"
  },
  "sales-enviado-sucesso": {
    pt: "Enviado com sucesso.",
    es: "Enviado con éxito!"
  },
  "sales-atualizado-sucesso": {
    pt: "Atualizado com sucesso.",
    es: "Actualizado con éxito!"
  },

  "sales-atualizacao-pedidos": {
    pt: "Atualização de pedidos",
    es: "Actualización de pedidos"
  },
  "sales-acao": {
    pt: "Ação",
    es: "Acción"
  },
  "sales-progresso": {
    pt: "Progresso",
    es: "Progreso"
  },
  "sales-verificacoes": {
    pt: "Verificações",
    es: "Verificaciones"
  },
  "sales-atualizacoes": {
    pt: "Atualizações",
    es: "Atualizaciones"
  },

  //
  "thema-cores": {
    pt: "Cores",
    es: "Colores"
  },
  "thema-avancado": {
    pt: "Avançado",
    es: "Avanzado"
  },
  "thema-combinacao-cores": {
    pt: "Combinação de cores:",
    es: "Combinación de colores:"
  },
  "thema-vermelho": {
    pt: "Vermelho",
    es: "Rojo"
  },
  "thema-amarelo": {
    pt: "Amarelo",
    es: "Amarillo"
  },
  "thema-escuro": {
    pt: "Escuro",
    es: "Oscuro"
  },
  "thema-cabecalho": {
    pt: "Cabeçalho",
    es: "Encabezado"
  },
  "thema-texto-cabecalho": {
    pt: "Texto cabeçalho",
    es: "Texto encabezado"
  },
  "thema-fundo": {
    pt: "Fundo",
    es: "Fondo"
  },
  "thema-produto": {
    pt: "Produto",
    es: "Producto"
  },
  "thema-nome": {
    pt: "Nome",
    es: "Nombre"
  },
  "thema-botao": {
    pt: "Botão",
    es: "Botón"
  },
  "thema-texto-botao": {
    pt: "Texto botão",
    es: "Texto Botón"
  },
  "thema-ajuda": {
    pt: "Precisa de ajuda",
    es: "¿Necesitas ayuda?"
  },
  "thema-salvar": {
    pt: "Salvar",
    es: "Guardar"
  },
  "thema-cuidado-salvar": {
    pt: "Cuidado - Alterações não salvas",
    es: "Precaución: Cambios no guardados"
  },

  "thema-checkout-loja": {
    pt: "Checkout loja",
    es: "Checkout de la tienda"
  },
  "thema-necessario-pagina": {
    pt: "É necessário criar uma página em sua plataforma e colar nosso código.",
    es: "Es necesario crear una página en su plataforma y pegar nuestro código."
  },
  "thema-criar-pagina": {
    pt: "Criar página de downloads",
    es: "Crear página de Downloads"
  },
  "thema-vamos-criar-pagina": {
    pt: "Vamos criar uma página em sua loja, para seus clientes baixarem os arquivos digitais comprados.",
    es: "Vamos a crear una página en su tienda para que sus clientes descarguen los archivos digitales comprados."
  },
  "thema-na-sua-plataforma": {
    pt: "Na sua plataforma, vá até criar página.",
    es: "En tu plataforma, ve a \"crear página\"."
  },
  "thema-no-titulo-pagina": {
    pt: 'No título da página digite "Downloads"',
    es: 'En el título de la página escriba "Downloads".'
  },
  "thema-no-form-escreva": {
    pt: 'No formulário "Escreva o conteúdo da sua página" clique na opção Código Fonte e cole o codigo HTML abaixo:',
    es: 'En el formulario "Escriba el contenido de su página", haga clic en la opción Código Fuente y pegue el código HTML abajo:'
  },
  "thema-na-plataforma": {
    pt: 'Na sua plataforma, desça até o final da página e digite "Downloads" em URL da página',
    es: 'En su plataforma, baje hasta el final de la página y escriba "Downloads" en URL de la página'
  },
  "thema-para-salvar": {
    pt: 'Para Salvar, basta clicar no botão "Criar Página"',
    es: 'Para guardar, simplemente haga clic en el botón "Crear Página"'
  },
  "thema-obs": {
    pt: 'Observação: Caso tenha alguma dúvida, veja o vídeo ao lado.',
    es: "Nota: Si tiene alguna duda, vea el video al lado."
  },
  "thema-botoes": {
    pt: 'Botôes',
    es: "Botones."
  },


  //
  "assinatura-assine": {
    pt: "Assine o",
    es: "Suscríbete a"
  },
  "assinatura-descontos-app": {
    pt: "para ter descontos nesse e em outros aplicativos!",
    es: "para obtener descuentos en esta y otras aplicaciones!"
  },
  "assinatura-acesse-ja": {
    pt: "Acesse já",
    es: "Ingresa ahora!"
  },
  "assinatura-plano-atual": {
    pt: "Plano Atual",
    es: "Plan Actual"
  },
  "assinatura-trocar-plano": {
    pt: "Trocar Plano",
    es: "Cambiar plan"
  },

  //
  "ajuda-atendimento": {
    pt: "Atendimento",
    es: "Atendimiento"
  },
  "ajuda-suporte-whats": {
    pt: "Suporte via Whatsapp",
    es: "Soporte vía Whatsapp"
  },
  "ajuda-ir-whats": {
    pt: "Ir para Whatsapp",
    es: "Ir al Whatsapp"
  },
  "ajuda-canais": {
    pt: "Canais",
    es: "Canales"
  },
  "ajuda-suporte-forum": {
    pt: "Suporte Fórum",
    es: "Soporte Foro"
  },
  "ajuda-ir-forum": {
    pt: "Ir para fórum",
    es: "Ir al Foro"
  },
  //
  "medias-em": {
    pt: "Em",
    es: "En"
  },
  "medias-produtos": {
    pt: "produtos",
    es: "productos"
  },
  "medias-deletar-selecionados": {
    pt: "Deletar arquivos selecionados",
    es: "Borrar archivos seleccionados"
  },
  "medias-pesquisar": {
    pt: "Pesquisar",
    es: "Buscar"
  },
  "medias-baixar-arquivo": {
    pt: "Baixar arquivo",
    es: "Descargar archivo"
  },
  "medias-renomear-arquivo": {
    pt: "Renomear arquivo",
    es: "Renombrar arquivo"
  },
  "permissoes-copiadas": {
    pt: "Permissões copiadas",
    es: "Permisos copiados"
  },
  "medias-deletar-arquivo": {
    pt: "Deletar arquivo",
    es: "Borrar archivo"
  },
  "medias-nao-midias": {
    pt: "Você ainda não possuí nenhuma mídia. ",
    es: "Aún no tienes ningún archivo."
  },
  "medias-excluido-sucesso": {
    pt: "Excluído com sucesso.",
    es: "Eliminado con éxito."
  },
  "medias-renomear-midia": {
    pt: "Renomear mídia",
    es: "Renombrar archivo"
  },
  "medias-salvar": {
    pt: "Salvar",
    es: "Guardar"
  },
  "medias-upload-arquivos": {
    pt: "Upload de arquivos",
    es: "Subir archivos"
  },
  "medias-arraste-arquivos": {
    pt: "Arrastre as mídias para upload",
    es: "Arrastra los archivos para subirlos"
  },
  "medias-escolher-midias": {
    pt: "Selecionar arquivo",
    es: "Seleccionar archivo"
  },
  "medias-nenhum-arquivo": {
    pt: "Nenhuma mídia",
    es: "Ningún archivo"
  },
  "medias-arquivo": {
    pt: "Arquivos",
    es: "Archivos"
  },
  "medias-deseja-deletar": {
    pt: "Deseja deletar a mídia ",
    es: "¿Deseas eliminar el archivo "
  },

  //
  "header-fim-teste": {
    pt: "Fim do período de testes",
    es: "Fin del periodo de prueba."
  },
  "header-assinar": {
    pt: " Assinar",
    es: " Suscríbete"
  },
  "header-armazenamento": {
    pt: "Armazenamento",
    es: "Almacenamiento"
  },
  "header-comprar": {
    pt: "Comprar mais espaço",
    es: "Comprar más espacio"
  },

  "header-detalhes": {
    pt: "Detalhes",
    es: "Detalles"
  },

  "header-imagem": {
    pt: "Imagem",
    es: "Imagen"
  },

  "header-outros": {
    pt: "Outros",
    es: "Otros"
  },

  //
  "products-sincronizar-dados": {
    pt: "Sincronizar dados desse produto com sua plataforma.",
    es: "Sincronizar datos de este producto con su plataforma"
  },
  "products-": {
    pt: "Produtos sincronizados com sucesso",
    es: "Producto sincronizadocon éxito"
  },
  "products-upload-arquivos": {
    pt: "Upload de arquivo",
    es: "Subir archivo"
  },
  "products-vincular-arquivo": {
    pt: "Vincular arquivo existente",
    es: "Vincular archivo existente"
  },
  "products-anexar": {
    pt: "anexar",
    es: "Adjuntar"
  },
  "products-anexar-arquivo": {
    pt: "Anexar arquivo",
    es: "Adjuntar archivo"
  },
  "products-sem-midias": {
    pt: "Sem mídias",
    es: "Sin medios"
  },
  "products-com-midias": {
    pt: "Com arquivos",
    es: "Con medios"
  },
  "products-fechar-variantes": {
    pt: "Fechar variantes",
    es: "Cerrar variantes"
  },
  "products-digite-url": {
    pt: "Digite a URL que deseja conectar, um nome para identificar a url, adicione a fila e depois click no botão salvar.",
    es: "Introduzca la URL que desea conectar, agreguela a la fila y despues haga clic en Guardar."
  },
  "products-url-add": {
    pt: "URLS adicionadas",
    es: "URLs agregados"
  },
  "products-nenhuma-url": {
    pt: "Nenhuma URL adicionada",
    es: "Ninguna URL agregada"
  },
  "products-add-anexo": {
    pt: "Adicionar anexo",
    es: " Adjuntar archivo"
  },
  "products-selecione-abaixo-midias": {
    pt: "Selecione abaixo os arquivos que deseja vincular ao produto.",
    es: "Seleccione abajo los archivos que desea vincular."
  },
  "products-atualizacao-produtos": {
    pt: "Atualização de produtos",
    es: "Actualización de productos"
  },
  "products-todos-produtos": {
    pt: "Todos os produtos",
    es: "Todos los productos"
  },

  //
  "integrations-existe-integracao": {
    pt: "Já existe uma integração",
    es: "Ya posees una integración activa."
  },
  "integrations-integre-plataforma": {
    pt: "Por favor integrar uma plataforma primeiro",
    es: "Primero integre una plataforma"
  },

  //
  "page-products-title": {
    pt: "Produtos",
    es: "Productos"
  },
  "page-products-description": {
    pt: "Vincule arquivos aos produtos disponíveis na sua loja.",
    es: "Vincula archivos a los productos disponibles en tu tienda."
  },
  "page-variants-title": {
    pt: "Variações",
    es: "Variaciones"
  },
  "page-medias-title": {
    pt: "Galeria",
    es: "Galería"
  },
  "page-medias-description": {
    pt: "Saiba quais arquivos estão disponíveis no seu Dijital e o que você pode fazer com eles.",
    es: "Descubre qué archivos tienes disponibles en Dijital y qué puedes hacer con ellos."
  },
  "page-orders-title": {
    pt: "Pedidos",
    es: "Pedidos"
  },
  "page-orders-description": {
    pt: "Com o Dijital, ofereça uma página de download personalizada para que seus clientes baixem os arquivos digitais adquiridos. O link é enviado automaticamente após a confirmação da venda.",
    es: "Con Dijital, ofrece una página de descarga personalizada para que tus clientes descarguen los archivos digitales que compraron. El enlace se envía automáticamente cuando se confirma la venta."
  },
  "page-licenses-title": {
    pt: "Licenças",
    es: "Licencias"
  },
  "page-licenses-description": {
    pt: "Com o Dijital, ofereça uma página de acesso personalizado para que seus clientes acessem as licenças adquiridas. O link é enviado automaticamente após a confirmação da venda.",
    es: "Con Dijital, ofrece una página de acceso personalizada para que tus clientes accedan a las licencias que compraron. El enlace se envía automáticamente cuando se confirma la venta."
  },
  "page-codes-title": {
    pt: "Códigos",
    es: "Códigos"
  },
  "page-codes-description": {
    pt: "Vincule códigos aos produtos disponíveis na sua loja.",
    es: "Vincula códigos a los productos disponibles en tu tienda."
  },
  "page-integrations-title": {
    pt: "Integrações",
    es: "Integraciones"
  },
  "page-integrations-description": {
    pt: "Integre sua plataforma e comece a vender.",
    es: "Integra tu plataforma y empieza a vender."
  },
  "page-integrations-list-description": {
    pt: "Integre sua plataforma de e-commerce para gerenciar seus produtos digitais. É possível combinar com o SAK,  usando whatsapp e melhorando a experiência do cliente.",
    es: "Integra tu plataforma de comercio electrónico para gestionar tus productos digitales. También puedes combinarla con SAK para usar WhatsApp y mejorar la experiencia de tus clientes."
  },
  "integrations-card-nuvemshop": {
    pt: "Integre sua conta Nuvemshop e entregue produtos digitais de forma automática.",
    es: "Integra tu cuenta de Tiendanube y entrega productos digitales automáticamente."
  },
  "integrations-card-shopify": {
    pt: "Integre sua conta Shopify e entregue produtos digitais de forma automática.",
    es: "Integra tu cuenta de Shopify y entrega productos digitales automáticamente."
  },
  "integrations-card-yampi": {
    pt: "Integre sua conta Yampi e entregue produtos digitais de forma automática.",
    es: "Integra tu cuenta de Yampi y entrega productos digitales automáticamente."
  },
  "integrations-card-sak": {
    pt: "Combine o poder do SAK para entregar produtos digitais pelo whatsapp",
    es: "Aprovecha SAK para entregar productos digitales por WhatsApp."
  },
  "integrations-excluir-integracao": {
    pt: "Deseja excluir a integração",
    es: "¿Quieres eliminar la integración con"
  },
  "integrations-excluir-botao": {
    pt: "Excluir integração",
    es: "Eliminar integración"
  },
  "products-pesquisar-nome": {
    pt: "Pesquisar por nome",
    es: "Buscar por nombre"
  },
  "products-sincronizar": {
    pt: "Sincronizar",
    es: "Sincronizar"
  },
  "products-th-produto": {
    pt: "Produto",
    es: "Producto"
  },
  "products-th-variacoes": {
    pt: "Variações",
    es: "Variaciones"
  },
  "products-th-variacao": {
    pt: "Variação",
    es: "Variación"
  },
  "products-th-arquivos": {
    pt: "Arquivos",
    es: "Archivos"
  },
  "products-th-preview": {
    pt: "Preview",
    es: "Vista previa"
  },
  "products-th-editar": {
    pt: "Editar",
    es: "Editar"
  },
  "products-filtro-com-arquivos": {
    pt: "Com arquivos",
    es: "Con archivos"
  },
  "products-filtro-sem-arquivos": {
    pt: "Sem arquivos",
    es: "Sin archivos"
  },
  "products-sinc-completa": {
    pt: "Sincronização Completa",
    es: "Sincronización completa"
  },
  "products-sinc-completa-desc": {
    pt: "Sincronizamos todos os produtos selecionados",
    es: "Sincronizamos todos los productos seleccionados"
  },
  "products-anexar-link": {
    pt: "Anexar link",
    es: "Adjuntar enlace"
  },
  "products-anexar-galeria": {
    pt: "Anexar da galeria",
    es: "Adjuntar desde la galería"
  },
  "products-pagination-mostrando": {
    pt: "Mostrando",
    es: "Mostrando"
  },
  "products-pagination-de": {
    pt: "de",
    es: "de"
  },
  "products-pagination-resultados": {
    pt: "resultados",
    es: "resultados"
  },
  "products-pagination-proximo": {
    pt: "Proximo",
    es: "Siguiente"
  },
  "products-pagination-anterior": {
    pt: "Anterior",
    es: "Anterior"
  },
  "products-menu-anexar-midias": {
    pt: "Anexar mídias",
    es: "Adjuntar archivos"
  },
  "products-menu-anexar-midias-desc": {
    pt: "Anexar arquivos ou URLs nesse produto.",
    es: "Adjuntar archivos o URLs a este producto."
  },
  "products-menu-sincronizar-desc": {
    pt: "Sincronizar os dados desse produto com a sua plataforma.",
    es: "Sincroniza los datos de este producto con tu plataforma."
  },
  "products-sinc-titulo": {
    pt: "Sincronizando produtos",
    es: "Sincronizando productos"
  },
  "products-sinc-aguarde": {
    pt: "Aguarde enquanto sincronizamos os produtos selecionados.",
    es: "Espera mientras sincronizamos los productos seleccionados."
  },
  "products-sinc-completo": {
    pt: "Completo",
    es: "Completo"
  },
  "products-sinc-sincronizando": {
    pt: "Sincronizando",
    es: "Sincronizando"
  },
  "products-sinc-aguardando": {
    pt: "Aguardando",
    es: "En espera"
  },
  "variants-menu-anexar-arquivos-desc": {
    pt: "Anexar arquivos nesse produto.",
    es: "Adjuntar archivos a este producto."
  },
  "variants-menu-anexar-link-desc": {
    pt: "Anexar links nesse produto.",
    es: "Adjuntar enlaces a este producto."
  },
  "variants-menu-anexar-galeria-desc": {
    pt: "Anexar arquivos ou Links da galeria nesse produto.",
    es: "Adjuntar archivos o enlaces de la galería a este producto."
  },
  "variants-menu-upload-preview": {
    pt: "Upload preview",
    es: "Subir archivo de vista previa"
  },
  "variants-menu-upload-preview-desc": {
    pt: "Fazer upload apenas de PDF para preview.",
    es: "Sube solo archivos PDF para la vista previa."
  },
  "variants-menu-anexar-licenca": {
    pt: "Anexar Licença",
    es: "Adjuntar licencia"
  },
  "variants-menu-anexar-licenca-desc": {
    pt: "Anexar codigos de uma licença nesse produto.",
    es: "Adjuntar códigos de una licencia a este producto."
  },
  "variants-desvincular-midia": {
    pt: "Deseja desvincular a mídia",
    es: "¿Quieres desvincular el archivo"
  },
  "variants-desvincular-licenca": {
    pt: "Deseja desvincular a licença",
    es: "¿Quieres desvincular la licencia"
  },
  "products-upload-titulo": {
    pt: "Upload arquivos",
    es: "Subir archivos"
  },
  "products-upload-desc": {
    pt: "Faça o upload dos arquivos que voce deseja anexar.",
    es: "Sube los archivos que quieras adjuntar."
  },
  "products-upload-dropzone": {
    pt: "Para iniciar upload, clique aqui ou arraste e solte seus arquivos de tamanho máximo 100MB.",
    es: "Haz clic aquí o arrastra y suelta tus archivos para subirlos. Tamaño máximo: 100 MB por archivo."
  },
  "products-upload-carregando": {
    pt: "Carregando arquivos",
    es: "Cargando archivos"
  },
  "products-upload-carregados": {
    pt: "Arquivos carregados",
    es: "Archivos cargados"
  },
  "products-link-titulo": {
    pt: "Cadastrar link",
    es: "Agregar enlace"
  },
  "products-link-desc": {
    pt: "Cadastre o link que voce deseja anexar.",
    es: "Agrega el enlace que quieras adjuntar."
  },
  "products-link-nome": {
    pt: "Nome para o cliente",
    es: "Nombre para el cliente"
  },
  "products-link-nome-placeholder": {
    pt: "Ex.: Aulas online",
    es: "Ej.: Clases online"
  },
  "products-link-url": {
    pt: "URL",
    es: "URL"
  },
  "products-link-url-placeholder": {
    pt: "https://",
    es: "https://"
  },
  "products-link-cadastrar": {
    pt: "Cadastrar e anexar",
    es: "Agregar y adjuntar"
  },
  "products-link-cadastrados": {
    pt: "Links cadastrados",
    es: "Enlaces agregados"
  },
  "products-galeria-desc": {
    pt: "Pesquise o arquivo e clique em anexar.",
    es: "Busca el archivo y haz clic en Adjuntar."
  },
  "products-galeria-buscar-label": {
    pt: "Pesquisar arquivo ou link",
    es: "Buscar archivo o enlace"
  },
  "products-galeria-buscar": {
    pt: "Buscar na galeria...",
    es: "Buscar en la galería..."
  },
  "products-galeria-lista": {
    pt: "Lista de arquivos",
    es: "Lista de archivos"
  },
  "products-galeria-anexar": {
    pt: "Anexar +",
    es: "Adjuntar +"
  },

  "products-galeria-anexando": {
    pt: "Anexando...",
    es: "Adjuntando..."
  },
  "products-galeria-anexado": {
    pt: "Anexado",
    es: "Adjuntado"
  },
  "products-upload-preview-erro-pdf": {
    pt: "Apenas arquivos PDF são permitidos para preview.",
    es: "Solo se permiten archivos PDF para la vista previa."
  },
  "products-upload-preview-erro": {
    pt: "Erro ao fazer upload do preview.",
    es: "Error al subir la vista previa."
  },
  "medias-table-tipo": {
    pt: "Tipo",
    es: "Tipo"
  },
  "medias-table-tamanho": {
    pt: "Tamanho",
    es: "Tamaño"
  },
  "medias-cadastrar": {
    pt: "Cadastrar",
    es: "Agregar"
  },
  "medias-excluir": {
    pt: "Excluir",
    es: "Eliminar"
  },
  "medias-exclusao-completa": {
    pt: "Exclusão Completa",
    es: "Eliminación completa"
  },
  "medias-exclusao-completa-desc": {
    pt: "Excluímos todos os arquivos selecionados",
    es: "Eliminamos todos los archivos seleccionados"
  },
  "medias-menu-arquivos-desc": {
    pt: "Cadastre seus arquivos na galeria para posteriormente anexar em seus produtos.",
    es: "Sube archivos a la galería para adjuntarlos a tus productos más adelante."
  },
  "medias-menu-links": {
    pt: "Links",
    es: "Enlaces"
  },
  "medias-menu-links-desc": {
    pt: "Cadastre seus links na galeria para posteriormente anexar em seus produto.",
    es: "Agrega enlaces a la galería para adjuntarlos a tus productos más adelante."
  },
  "medias-menu-acessar": {
    pt: "Acessar",
    es: "Acceder"
  },
  "medias-menu-acessar-desc": {
    pt: "Acessar essa URL.",
    es: "Acceder a esta URL."
  },
  "medias-menu-baixar": {
    pt: "Baixar",
    es: "Descargar"
  },
  "medias-menu-baixar-desc": {
    pt: "Baixar esse arquivo.",
    es: "Descargar este archivo."
  },
  "medias-menu-excluir-desc": {
    pt: "Excluír essa arquivo.",
    es: "Eliminar este archivo."
  },
  "medias-menu-renomear": {
    pt: "Renomear",
    es: "Renombrar"
  },
  "medias-menu-renomear-desc": {
    pt: "Renomear essa arquivo.",
    es: "Renombrar este archivo."
  },
  "medias-menu-cadastrar-url": {
    pt: "Cadastrar URL",
    es: "Agregar URL"
  },
  "medias-menu-cadastrar-url-desc": {
    pt: "Cadastrar uma URL ou link de acesso.",
    es: "Agrega una URL o un enlace de acceso."
  },
  "medias-menu-cadastrar-arquivo": {
    pt: "Cadastrar Arquivo",
    es: "Subir archivo"
  },
  "medias-menu-cadastrar-arquivo-desc": {
    pt: "Fazer upload de arquivos.",
    es: "Sube archivos a la galería."
  },
  "medias-renomear-nome-url": {
    pt: "nome da url",
    es: "nombre de la URL"
  },
  "medias-renomear-placeholder": {
    pt: "mídia",
    es: "archivo"
  },
  "medias-upload-limite": {
    pt: "Máximo de 100mb por arquivo.",
    es: "Máximo de 100 MB por archivo."
  },
  "medias-fechar-modal": {
    pt: "Deseja fechar o modal?",
    es: "¿Quieres cerrar esta ventana?"
  },
  "medias-excluindo-arquivos": {
    pt: "Excluindo arquivos",
    es: "Eliminando archivos"
  },
  "medias-excluindo-desc": {
    pt: "Aguarde enquanto excluímos os arquivos selecionados.",
    es: "Espera mientras eliminamos los archivos seleccionados."
  },
  "medias-excluido": {
    pt: "Excluído",
    es: "Eliminado"
  },
  "medias-excluindo": {
    pt: "Excluindo",
    es: "Eliminando"
  },
  "medias-aguardando": {
    pt: "Aguardando",
    es: "En espera"
  },
  "medias-erro-excluir": {
    pt: "Erro ao tentar excluir.",
    es: "Error al intentar eliminar."
  },
  "medias-erro-atualizar": {
    pt: "Erro ao tentar atualizar.",
    es: "Error al intentar actualizar."
  },
  "medias-atualizado-sucesso": {
    pt: "Atualizado com sucesso.",
    es: "Actualizado con éxito."
  },
  "medias-upload-completo": {
    pt: "completo",
    es: "completo"
  },
  "medias-acessar-url": {
    pt: "Acessar URL",
    es: "Acceder a la URL"
  },
  "medias-nome-url": {
    pt: "Nome para URL",
    es: "Nombre para URL"
  },
  "medias-salvando": {
    pt: "Salvando",
    es: "Guardando"
  },
  "sales-pedido": { pt: "Pedido", es: "Pedido" },
  "sales-pesquisar-pedido": { pt: "Pesquisar por pedido", es: "Buscar por pedido" },
  "sales-filtro-intervalo": { pt: "a", es: "a" },
  "sales-filtro-sincronizar": { pt: "Sincronizar", es: "Sincronizar" },
  "sales-reenviar-email": { pt: "Reenviar e-mail", es: "Reenviar correo" },
  "sales-th-email": { pt: "E-mail", es: "Correo electrónico" },
  "sales-th-nome-email": { pt: "Nome/Email", es: "Nombre/Email" },
  "sales-th-envio-email": { pt: "Envio e-mail", es: "Envío de correo" },
  "sales-th-envio-whatsapp": { pt: "Envio Whatsapp", es: "Envío por WhatsApp" },
  "sales-th-produtos-chaves": { pt: "Produtos/chaves", es: "Productos/claves" },
  "sales-th-imagem": { pt: "Imagem", es: "Imagen" },

  "sales-status-bloqueado": { pt: "Bloqueado", es: "Bloqueado" },
  "sales-status-liberado": { pt: "Liberado", es: "Desbloqueado" },
  "sales-status-enviado": { pt: "Enviado", es: "Enviado" },
  "sales-status-enviando": { pt: "Enviando", es: "Enviando" },
  "sales-status-aguardando": { pt: "Aguardando", es: "En espera" },
  "sales-reenvio-completo": { pt: "Reenvio Completo", es: "Reenvío completo" },
  "sales-reenvio-completo-desc": { pt: "Reenviamos todos os emails dos pedidos selecionados", es: "Reenviamos todos los correos de los pedidos seleccionados" },
  "sales-reenviando-emails": { pt: "Reenviando e-mails", es: "Reenviando correos" },
  "sales-reenviando-desc": { pt: "Aguarde enquanto reenviamos os emails dos pedidos selecionados.", es: "Espera mientras reenviamos los correos de los pedidos seleccionados." },
  "sales-sinc-pedido-desc": { pt: "Buscar pedido que ainda não sincronizou com o Dijital", es: "Busca un pedido que aún no se haya sincronizado con Dijital" },
  "sales-sinc-todos-desc": { pt: "Sincronizar pedidos com o Dijital", es: "Sincroniza los pedidos con Dijital" },
  "sales-sinc-pedido": { pt: "Sincronizar pedido", es: "Sincronizar pedido" },
  "sales-numero-pedido": { pt: "N° pedido:", es: "N.º de pedido:" },
  "sales-erro-sincronizar": { pt: "Não foi possível sincronizar o pedido.", es: "No se pudo sincronizar el pedido." },
  "sales-sincronizado-sucesso": { pt: "Pedido sincronizado com sucesso.", es: "Pedido sincronizado correctamente." },
  "sales-menu-editar-email": { pt: "Editar e-mail", es: "Editar correo electrónico" },
  "sales-menu-editar-email-desc": { pt: "Atualizar e-mail do pedido", es: "Actualizar el correo del pedido" },
  "sales-menu-reenviar-email-desc": { pt: "Enviar ou reenviar o e-mail do pedido", es: "Enviar o reenviar el correo del pedido" },
  "sales-menu-reenviar-whatsapp": { pt: "Reenviar Whatsapp", es: "Reenviar WhatsApp" },
  "sales-menu-reenviar-whatsapp-desc": { pt: "Enviar ou reenviar whatsapp do pedido", es: "Enviar o reenviar el WhatsApp del pedido" },
  "sales-menu-bloquear": { pt: "Bloquear", es: "Bloquear" },
  "sales-menu-desbloquear": { pt: "Desbloquear", es: "Desbloquear" },
  "sales-menu-bloquear-desc": { pt: "Bloquear ou desbloquer a página de downloads desse pedido", es: "Bloquear o desbloquear la página de descargas de este pedido" },
  "sales-menu-acessar-desc": { pt: "Acessar página de downloads desse pedido.", es: "Acceder a la página de descargas de este pedido." },
  "sales-menu-licenca": { pt: "Licença", es: "Licencia" },
  "sales-menu-licenca-desc": { pt: "Ver dados da licença desse pedido.", es: "Ver los datos de la licencia de este pedido." },
  "sales-menu-emails": { pt: "E-mails", es: "Correos electrónicos" },
  "sales-menu-emails-desc": { pt: "Historico de e-mails desse pedido.", es: "Historial de correos de este pedido." },
  "sales-erro-enviar": { pt: "Erro ao tentar enviar.", es: "Error al intentar enviar." },
  "sales-erro-status": { pt: "Erro ao atualizar status", es: "Error al actualizar el estado" },
  "sales-erro-email": { pt: "Erro ao atualizar email", es: "Error al actualizar el correo electrónico" },
  "sales-emails-enviados": { pt: "E-mails enviados", es: "Correos enviados" },
  "sales-emails-atencao": { pt: "Atenção", es: "Atención" },
  "sales-emails-aviso": { pt: "O histórico de envio de e-mails será contabilizado apenas a partir do dia 13/05/2025.", es: "El historial de envío de correos solo se contabilizará a partir del 13/05/2025." },
  "sales-emails-carregando": { pt: "Carregando e-mails", es: "Cargando correos" },
  "sales-emails-pedido-enviado": { pt: "Pedido enviado", es: "Pedido enviado" },
  "sales-emails-codigos-enviados": { pt: "Códigos/chaves enviados", es: "Códigos/claves enviados" },
  "sales-emails-nenhum": { pt: "Nenhum e-mail encontrado.", es: "No se encontraron correos electrónicos." },
  "sales-emails-para": { pt: "Para:", es: "Para:" },
  "sales-emails-assunto": { pt: "Assunto:", es: "Asunto:" },
  "sales-licenca-resumo": { pt: "Resumo", es: "Resumen" },
  "sales-licenca-cliente": { pt: "Cliente", es: "Cliente" },
  "sales-sinc-feedback": { pt: "Feedback", es: "Feedback" },
  "thema-checkout": {
    pt: "Checkout",
    es: "Checkout"
  },
  "thema-azul": {
    pt: "Azul",
    es: "Azul"
  },
  "thema-verde": {
    pt: "Verde",
    es: "Verde"
  },
  "thema-claro": {
    pt: "Claro",
    es: "Claro"
  },
  "thema-personalizado": {
    pt: "Personalizado",
    es: "Personalizado"
  },
  "thema-titulo": {
    pt: "Título",
    es: "Título"
  },
  "thema-restaurar": {
    pt: "Restaurar",
    es: "Restaurar"
  },
  "thema-cor": {
    pt: "Cor",
    es: "Color"
  },
  "thema-cinza": {
    pt: "Cinza",
    es: "Gris"
  },
  "thema-roxo": {
    pt: "Roxo",
    es: "Morado"
  },
  "thema-rosa": {
    pt: "Rosa",
    es: "Rosa"
  },
  "thema-titulo-pagina-placeholder": {
    pt: "Título da sua página.",
    es: "Título de tu página."
  },
  "thema-subtitulo": {
    pt: "Subtítulo",
    es: "Subtítulo"
  },
  "thema-subtitulo-pagina-placeholder": {
    pt: "Subtítulo de sua página.",
    es: "Subtítulo de tu página."
  },
  "thema-download": {
    pt: "Download",
    es: "Descarga"
  },
  "thema-download-acao": {
    pt: "Download",
    es: "Descargar"
  },
  "thema-baixar": {
    pt: "Baixar",
    es: "Descargar"
  },
  "thema-link": {
    pt: "Link",
    es: "Enlace"
  },
  "thema-descartar": {
    pt: "DESCARTAR",
    es: "DESCARTAR"
  },
  "thema-preview-midia": {
    pt: "Mídia",
    es: "Archivo"
  },
  "thema-preview-tipo": {
    pt: "Tipo",
    es: "Tipo"
  },
  "thema-preview-produto": {
    pt: "Nome do produto",
    es: "Nombre del producto"
  },
  "thema-preview-imagens": {
    pt: "Kit imagens",
    es: "Kit de imágenes"
  },
  "thema-pagina-downloads": {
    pt: "Página downloads",
    es: "Página de descargas"
  },
  "thema-iframe": {
    pt: "Iframe",
    es: "Iframe"
  },
  "thema-texto": {
    pt: "Texto",
    es: "Texto"
  },
  "thema-link-downloads": {
    pt: "Link para a página de downloads",
    es: "Enlace a la página de descargas"
  },
  "thema-link-downloads-desc": {
    pt: "Adicione na sua loja um link para a página de downloads, onde seus clientes podem baixar os arquivos digitais comprados.",
    es: "Agrega a tu tienda un enlace a la página de descargas para que tus clientes puedan descargar los archivos digitales que compraron."
  },
  "thema-link-downloads-instrucao": {
    pt: "Copie o link e adicione o na sua loja, botão ou página.",
    es: "Copia el enlace y agrégalo a tu tienda, a un botón o a una página."
  },
  "thema-codigo-copiado": {
    pt: "Código copiado.",
    es: "Código copiado."
  },
  "marca-agua-remover-local": {
    pt: "Remover imagem local",
    es: "Eliminar imagen local"
  },
  "marca-agua-remover-api": {
    pt: "Remover imagem da API",
    es: "Eliminar imagen de la API"
  },
  "marca-agua-posicao": {
    pt: "Posição",
    es: "Posición"
  },
  "marca-agua-posicao-TopLeft": { pt: "superior esquerda", es: "superior izquierda" },
  "marca-agua-posicao-TopCenter": { pt: "superior central", es: "superior central" },
  "marca-agua-posicao-TopRight": { pt: "superior direita", es: "superior derecha" },
  "marca-agua-posicao-MiddleLeft": { pt: "central esquerda", es: "central izquierda" },
  "marca-agua-posicao-MiddleCenter": { pt: "centro", es: "centro" },
  "marca-agua-posicao-MiddleRight": { pt: "central direita", es: "central derecha" },
  "marca-agua-posicao-BottomLeft": { pt: "inferior esquerda", es: "inferior izquierda" },
  "marca-agua-posicao-BottomCenter": { pt: "inferior central", es: "inferior central" },
  "marca-agua-posicao-BottomRight": { pt: "inferior direita", es: "inferior derecha" },
  "thema-tempo-disponivel": {
    pt: "Tempo disponível",
    es: "Tiempo disponible"
  },
  "thema-dias": {
    pt: "dias",
    es: "días"
  },
  "thema-ilimitado": {
    pt: "Ilimitado",
    es: "Ilimitado"
  },
  "thema-seguranca": {
    pt: "Segurança",
    es: "Seguridad"
  },
  "thema-seguranca-desc": {
    pt: "Defina por quanto tempo os downloads ficam disponíveis.",
    es: "Define por cuánto tiempo las descargas estarán disponibles."
  },
  "armazenamento-desc": {
    pt: "Acompanhe o uso do espaço da sua conta.",
    es: "Consulta el uso del espacio de tu cuenta."
  },
  "armazenamento-usado": {
    pt: "Usado",
    es: "Usado"
  },
  "armazenamento-limite": {
    pt: "Limite",
    es: "Límite"
  },
  "armazenamento-utilizado": {
    pt: "utilizado",
    es: "utilizado"
  },
  "yourmedias-erro": {
    pt: "Erro",
    es: "Error"
  },
  "yourmedias-erro-titulo": {
    pt: "Página indisponível",
    es: "Página no disponible"
  },
  "yourmedias-erro-desc": {
    pt: "Tivemos um problema ao carregar seus arquivos. Tente novamente mais tarde ou entre em contato com o suporte.",
    es: "Tuvimos un problema al cargar tus archivos. Inténtalo de nuevo más tarde o contacta al soporte."
  },
  "yourmedias-erro-tentar": {
    pt: "Tentar novamente",
    es: "Intentar de nuevo"
  },
  "yourmedias-sempermissao-titulo": {
    pt: "Link expirado",
    es: "Enlace expirado"
  },
  "yourmedias-sempermissao-desc": {
    pt: "Este link de download expirou ou não está mais disponível. Entre em contato com o vendedor para obter um novo acesso.",
    es: "Este enlace de descarga expiró o ya no está disponible. Contacta al vendedor para obtener un nuevo acceso."
  },
  "yourmedias-lock-desc": {
    pt: "Entre em contato com o vendedor para desbloqueio da página de downloads.",
    es: "Contacta al vendedor para desbloquear la página de descargas."
  },

  // ---- i18n: produtos / products-table ----
  "common-cancel": { pt: "Cancelar", es: "Cancelar" },
  "products-variants-label": { pt: "variantes", es: "variantes" },
  "products-variant-singular": { pt: "Variante", es: "Variante" },
  "products-files-label": { pt: "arquivos", es: "archivos" },
  "products-sincronizar-produto": { pt: "Sincronizar produto", es: "Sincronizar producto" },
  "products-empty-benefit-1": { pt: "Vincule arquivos digitais aos produtos da sua loja", es: "Vincula archivos digitales a los productos de tu tienda" },
  "products-empty-benefit-2": { pt: "Organize conteúdos por variante", es: "Organiza contenidos por variante" },
  "products-empty-benefit-3": { pt: "Entregue downloads automaticamente após a venda", es: "Entrega descargas automáticamente después de la venta" },
  "products-empty-benefit-4": { pt: "Sincronize produtos com a sua plataforma", es: "Sincroniza productos con tu plataforma" },
  "products-empty-benefit-5": { pt: "Gerencie mídias, links e previews em um só lugar", es: "Administra archivos, enlaces y vistas previas en un solo lugar" },
  "products-subtitle": { pt: "Organize o conteúdo entregue em cada variante.", es: "Organiza el contenido entregado en cada variante." },
  "products-selected-suffix": { pt: "selecionada(s)", es: "seleccionada(s)" },
  "products-add-content": { pt: "Adicionar conteúdo", es: "Agregar contenido" },
  "products-add-pdf": { pt: "+ Adicionar PDF", es: "+ Agregar PDF" },
  "products-clear-selection": { pt: "Fechar e limpar seleção", es: "Cerrar y limpiar selección" },
  "products-loading-variants": { pt: "Carregando variantes", es: "Cargando variantes" },
  "products-file-singular": { pt: "Arquivo", es: "Archivo" },
  "products-link-singular": { pt: "Link", es: "Enlace" },
  "products-license-singular": { pt: "Licença", es: "Licencia" },
  "products-no-variants": { pt: "Nenhuma variante encontrada para este produto.", es: "No se encontraron variantes para este producto." },
  "products-th-delivery-content": { pt: "Conteúdo para entrega", es: "Contenido para entrega" },
  "products-th-pdf-preview": { pt: "Prévia PDF", es: "Vista previa PDF" },
  "products-select-all-loaded-aria": { pt: "Selecionar todas as variantes carregadas", es: "Seleccionar todas las variantes cargadas" },
  "products-select-aria": { pt: "Selecionar", es: "Seleccionar" },
  "products-loading-more-variants": { pt: "Carregando mais variantes…", es: "Cargando más variantes…" },
  "products-select-variants-hint": { pt: "Selecione variantes para adicionar conteúdo ou prévia.", es: "Selecciona variantes para agregar contenido o vista previa." },
  "products-selecting-all": { pt: "Selecionando todas…", es: "Seleccionando todas…" },
  "products-select-all": { pt: "Selecionar todas", es: "Seleccionar todas" },
  "products-scroll-load-more": { pt: "role para carregar mais", es: "desplázate para cargar más" },
  "products-add-desc-file": { pt: "Enviar do computador", es: "Subir desde tu computadora" },
  "products-add-desc-gallery": { pt: "Usar conteúdo existente", es: "Usar contenido existente" },
  "products-add-desc-link": { pt: "Cadastrar endereço", es: "Agregar dirección" },
  "products-add-keys-title": { pt: "Chaves / códigos", es: "Claves / códigos" },
  "products-add-desc-keys": { pt: "Licenças e seriais", es: "Licencias y seriales" },
  "products-soon": { pt: "Em breve", es: "Próximamente" },
  // ---- common ----
  "common-close": { pt: "Fechar", es: "Cerrar" },
  "common-open": { pt: "Abrir", es: "Abrir" },
  "common-copy": { pt: "Copiar", es: "Copiar" },
  "common-back": { pt: "Voltar", es: "Volver" },
  "common-select-all-aria": { pt: "Selecionar todos", es: "Seleccionar todos" },
  "common-clear-selection": { pt: "Limpar seleção", es: "Limpiar selección" },

  // ---- sidebar / seguranca ----
  "sidebar-inicio": { pt: "Início", es: "Inicio" },
  "seguranca-placeholder": { pt: "Ex: 30", es: "Ej.: 30" },

  // ---- chaves / códigos modal ----
  "keys-err-load-codes": { pt: "Erro ao carregar códigos", es: "Error al cargar los códigos" },
  "keys-err-load-license-codes": { pt: "Não foi possível carregar os códigos desta licença", es: "No se pudieron cargar los códigos de esta licencia" },
  "keys-err-delete-license": { pt: "Erro ao excluir licença", es: "Error al eliminar la licencia" },
  "keys-err-file-type": { pt: "Use um arquivo .csv ou .txt", es: "Usa un archivo .csv o .txt" },
  "keys-err-no-keys-file": { pt: "Nenhuma chave encontrada no arquivo", es: "No se encontró ninguna clave en el archivo" },
  "keys-imported-suffix": { pt: "chave(s) importada(s)", es: "clave(s) importada(s)" },
  "keys-err-read-file": { pt: "Erro ao ler o arquivo", es: "Error al leer el archivo" },
  "keys-err-link-variant": { pt: "Erro ao vincular variante", es: "Error al vincular la variante" },
  "keys-err-create-license": { pt: "Erro ao criar licença", es: "Error al crear la licencia" },
  "keys-err-update-license": { pt: "Erro ao atualizar licença", es: "Error al actualizar la licencia" },
  "keys-err-create-code": { pt: "Erro ao cadastrar código", es: "Error al registrar el código" },
  "keys-err-update-code": { pt: "Erro ao atualizar código", es: "Error al actualizar el código" },
  "keys-err-remove-code": { pt: "Erro ao remover código", es: "Error al eliminar el código" },
  "keys-toast-title-required": { pt: "Informe o título para o cliente", es: "Indica el título para el cliente" },
  "keys-toast-add-one": { pt: "Adicione ao menos uma chave", es: "Agrega al menos una clave" },
  "keys-err-license-no-id": { pt: "Licença criada sem id", es: "Licencia creada sin id" },
  "keys-toast-updated-linked": { pt: "Licença atualizada e vinculada", es: "Licencia actualizada y vinculada" },
  "keys-toast-linked": { pt: "Licença vinculada com sucesso", es: "Licencia vinculada con éxito" },
  "keys-err-save-link": { pt: "Erro ao salvar e vincular", es: "Error al guardar y vincular" },
  "keys-toast-renamed": { pt: "Licença renomeada", es: "Licencia renombrada" },
  "keys-confirm-delete": { pt: "Excluir a licença", es: "¿Eliminar la licencia" },
  "keys-toast-deleted": { pt: "Licença excluída", es: "Licencia eliminada" },
  "keys-loading-licenses": { pt: "Carregando licenças…", es: "Cargando licencias…" },
  "keys-empty": { pt: "Nenhuma licença cadastrada.", es: "Aún no hay licencias registradas." },
  "keys-create-license": { pt: "Criar licença", es: "Crear licencia" },
  "keys-license-one": { pt: "licença", es: "licencia" },
  "keys-license-many": { pt: "licenças", es: "licencias" },
  "keys-available": { pt: "disponíveis", es: "disponibles" },
  "keys-keys-lower": { pt: "chaves", es: "claves" },
  "keys-options": { pt: "Opções", es: "Opciones" },
  "keys-add-codes": { pt: "Adicionar códigos", es: "Agregar códigos" },
  "keys-new-license": { pt: "Nova licença", es: "Nueva licencia" },
  "keys-title-label": { pt: "Título para o cliente", es: "Título para el cliente" },
  "keys-title-placeholder": { pt: "Chave de ativação", es: "Clave de activación" },
  "keys-keys": { pt: "Chaves", es: "Claves" },
  "keys-loading-codes": { pt: "Carregando códigos…", es: "Cargando códigos…" },
  "keys-already-used": { pt: "Já utilizado", es: "Ya utilizado" },
  "keys-mark-available": { pt: "Marcar como disponível", es: "Marcar como disponible" },
  "keys-mark-unavailable": { pt: "Marcar como indisponível", es: "Marcar como no disponible" },
  "keys-tooltip-unavailable": { pt: "Indisponível — clique para voltar a disponível", es: "No disponible — haz clic para volver a disponible" },
  "keys-tooltip-available": { pt: "Disponível — clique para marcar indisponível", es: "Disponible — haz clic para marcar como no disponible" },
  "keys-code-placeholder": { pt: "TESTE-AAAA-1111", es: "PRUEBA-AAAA-1111" },
  "keys-remove-code": { pt: "Remover código", es: "Eliminar código" },
  "keys-add-more": { pt: "+ Adicionar mais códigos", es: "+ Agregar más códigos" },
  "keys-import-csv": { pt: "Ou importar CSV · uma chave por linha", es: "O importar CSV · una clave por línea" },
  "keys-download-example": { pt: "Baixar exemplo", es: "Descargar ejemplo" },
  "keys-dropzone": { pt: "Clique ou arraste o arquivo aqui", es: "Haz clic o arrastra el archivo aquí" },
  "keys-dropzone-hint": { pt: "CSV ou TXT · uma chave por linha", es: "CSV o TXT · una clave por línea" },
  "keys-none-added": { pt: "Nenhuma chave adicionada.", es: "Ninguna clave agregada." },
  "keys-added-suffix": { pt: "chave(s) adicionada(s).", es: "clave(s) agregada(s)." },
  "keys-saving": { pt: "Salvando…", es: "Guardando…" },
  "keys-save-link": { pt: "Salvar e vincular", es: "Guardar y vincular" },
  "keys-license-name": { pt: "Nome da licença", es: "Nombre de la licencia" },
  "keys-header-list": { pt: "Licenças / códigos", es: "Licencias / códigos" },
  "keys-header-rename": { pt: "Renomear licença", es: "Renombrar licencia" },
  "keys-header-add": { pt: "Adicionar licenças / códigos", es: "Agregar licencias / códigos" },
  "keys-delivery-details": { pt: "Detalhes da entrega", es: "Detalles de la entrega" },

  // ---- upload modals ----
  "products-upload-click-drag": { pt: "Clique ou arraste os arquivos aqui", es: "Haz clic o arrastra los archivos aquí" },
  "products-upload-click-drag-pdf": { pt: "Clique ou arraste o PDF aqui", es: "Haz clic o arrastra el PDF aquí" },

  // ---- shared table / pagination / empty page ----
  "table-empty-title": { pt: "Nenhum dado encontrado", es: "No se encontraron datos" },
  "table-empty-desc": { pt: "Tente ajustar a busca ou os filtros.", es: "Intenta ajustar la búsqueda o los filtros." },
  "table-collapse": { pt: "Recolher", es: "Contraer" },
  "table-expand": { pt: "Expandir", es: "Expandir" },
  "table-showing": { pt: "Exibindo", es: "Mostrando" },
  "table-to": { pt: "a", es: "a" },
  "table-next": { pt: "Próxima", es: "Siguiente" },
  "empty-default-title": { pt: "Ainda não há nada para mostrar", es: "Aún no hay nada para mostrar" },
  "empty-default-benefit-1": { pt: "Organize seus arquivos e entregas em um só lugar", es: "Organiza tus archivos y entregas en un solo lugar" },
  "empty-default-benefit-2": { pt: "Vincule conteúdos aos produtos da sua loja", es: "Vincula contenidos a los productos de tu tienda" },
  "empty-default-benefit-3": { pt: "Automatize o envio após a confirmação da venda", es: "Automatiza el envío tras la confirmación de la venta" },
  "empty-default-benefit-4": { pt: "Acompanhe pedidos e status de envio", es: "Haz seguimiento de pedidos y del estado de envío" },
  "empty-default-benefit-5": { pt: "Ofereça uma experiência digital completa ao cliente", es: "Ofrece una experiencia digital completa al cliente" },

  // ---- medias / sales ----
  "medias-empty-benefit-1": { pt: "Cadastre arquivos e links na galeria", es: "Registra archivos y enlaces en la galería" },
  "medias-empty-benefit-2": { pt: "Reutilize mídias em vários produtos", es: "Reutiliza archivos en varios productos" },
  "medias-empty-benefit-3": { pt: "Organize PDFs, imagens, vídeos e URLs", es: "Organiza PDFs, imágenes, videos y URLs" },
  "medias-empty-benefit-4": { pt: "Anexe conteúdos com poucos cliques", es: "Adjunta contenidos con pocos clics" },
  "medias-empty-benefit-5": { pt: "Mantenha sua biblioteca digital atualizada", es: "Mantén tu biblioteca digital actualizada" },
  "medias-selected-one": { pt: "arquivo selecionado", es: "archivo seleccionado" },
  "medias-selected-many": { pt: "arquivos selecionados", es: "archivos seleccionados" },
  "sales-empty-benefit-1": { pt: "Acompanhe todos os pedidos da sua loja", es: "Haz seguimiento de todos los pedidos de tu tienda" },
  "sales-empty-benefit-2": { pt: "Veja status de liberação e envio de e-mail", es: "Consulta el estado de liberación y envío de correo" },
  "sales-empty-benefit-3": { pt: "Reenvie acessos com um clique", es: "Reenvía accesos con un clic" },
  "sales-empty-benefit-4": { pt: "Consulte produtos vinculados a cada pedido", es: "Consulta los productos vinculados a cada pedido" },
  "sales-empty-benefit-5": { pt: "Ofereça download automático após a venda", es: "Ofrece descarga automática tras la venta" },
  "sales-selected-one": { pt: "pedido selecionado", es: "pedido seleccionado" },
  "sales-selected-many": { pt: "pedidos selecionados", es: "pedidos seleccionados" },

  // ---- thema / personalizar ----
  "thema-badge-novo": { pt: "Novo", es: "Nuevo" },
  "thema-default-header": { pt: "Compra concluída com sucesso 🎉", es: "Compra completada con éxito 🎉" },
  "thema-default-title": { pt: "Obrigado por sua compra", es: "Gracias por tu compra" },
  "thema-default-message": { pt: "Seus arquivos", es: "Tus archivos" },
  "thema-default-button": { pt: "Baixar", es: "Descargar" },
  "thema-default-link": { pt: "Acessar", es: "Acceder" },
  "thema-email-helper": { pt: "Use o editor na área principal para personalizar o e-mail.", es: "Usa el editor del área principal para personalizar el correo electrónico." },
  "thema-default-email-subject": { pt: "Seu produto chegou!", es: "¡Tu producto llegó!" },
  "thema-default-email-message": {
    pt: "Seu produto chegou!\nObrigado por comprar conosco!.\nAcesso no botão abaixo.",
    es: "¡Tu producto llegó!\n¡Gracias por comprar con nosotros!\nAccede con el botón de abajo."
  },
  "thema-default-email-button": { pt: "Ver", es: "Ver" },
  "marca-agua-preview-alt": { pt: "Preview da marca d'água", es: "Vista previa de la marca de agua" },
  "thema-ardosia": { pt: "Ardósia", es: "Pizarra" },
  "thema-pedra": { pt: "Pedra", es: "Piedra" },
  "thema-rosa-escuro": { pt: "Rosa escuro", es: "Rosa oscuro" },
  "thema-laranja": { pt: "Laranja", es: "Naranja" },
  "thema-ambar": { pt: "Âmbar", es: "Ámbar" },
  "thema-lima": { pt: "Lima", es: "Lima" },
  "thema-esmeralda": { pt: "Esmeralda", es: "Esmeralda" },
  "thema-verde-azulado": { pt: "Verde-azulado", es: "Verde azulado" },
  "thema-ciano": { pt: "Ciano", es: "Cian" },
  "thema-ceu": { pt: "Céu", es: "Celeste" },
  "thema-indigo": { pt: "Índigo", es: "Índigo" },
  "thema-violeta": { pt: "Violeta", es: "Violeta" },
  "thema-fucsia": { pt: "Fúcsia", es: "Fucsia" },
  "thema-preto": { pt: "Preto", es: "Negro" },

  // ---- integrations ----
  "integrations-install": { pt: "Instalar", es: "Instalar" },
  "integrations-uninstall": { pt: "Desinstalar", es: "Desinstalar" },
  "integrations-connect": { pt: "Conectar", es: "Conectar" },
  "integrations-tag-loja": { pt: "Loja", es: "Tienda" },
  "integrations-config-prefix": { pt: "Configuração", es: "Configuración" },
  "integrations-fill-data": { pt: "Preencha os dados.", es: "Completa los datos." },
  "integrations-woo-url-placeholder": { pt: "URL do Woocommerce", es: "URL de Woocommerce" },
  "integrations-woo-url-required": { pt: "Adicione a url da sua loja Woocommerce", es: "Agrega la URL de tu tienda Woocommerce" },
  "integrations-shopify-domain-invalid": { pt: "Informe um domínio válido da loja Shopify (minhaloja.myshopify.com).", es: "Indica un dominio válido de tu tienda Shopify (mitienda.myshopify.com)." },
  "integrations-code-copied": { pt: "Código copiado.", es: "Código copiado." },

};
